// extracted by mini-css-extract-plugin
export default {"tooltip":"sn-z","sharingV2":"tn-z","sharingIconsV2":"un-z","links":"vn-z","link":"wn-z","facebookV2":"xn-z","twitterV2":"yn-z","pinterestV2":"zn-z"};